module.exports = __webpack_public_path__ + "static/media/silver-badge-alt.dfe6fa5b.svg";